import React from 'react';
import './Marquee.css';

const Marquee = () => {
  return (
    <div className="marquee-container">
      <div className="marquee-text">
          Urgently Seeking a 2 to 3‑Year Apprenticeship in Artificial Intelligence or Cybersecurity in Paris or the Suburbs of Paris to finance my studies and gain real experiences !!
      </div>
    </div>
  );
};

export default Marquee;
